import { queryOptions } from "@react/foundation/query";

import { logEntryRepository } from "../../repository/LogEntryRepository.ts";
import { useAuth } from "../contexts/auth/useAuth.ts";
import { useConfig } from "../contexts/config/useConfig.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useQueries() {
  const { userId } = useAuth();

  const { gridEpochId } = useConfig();

  return {
    getLogEntriesQueryOptions: queryOptions({
      queryFn: async () =>
        logEntryRepository.getAllByEpoch(userId, gridEpochId),
      queryKey: {
        group: () => ["logEntryRepository.getAllByEpoch", userId, gridEpochId],
      },
    }),
  };
}
